import type { DeleteEntityMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteEntityDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteEntity = createMutationHook({
  name: 'deleteEntity',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.entity.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Id: string }) => ({ Id: variables.Id }),
  invalidate: (trpc) => [
    trpc.frontend.entity.register.queryKey(),
    trpc.frontend.entity.getById.queryKey(),
  ],
  mapResponse: (): DeleteEntityMutation => ({
    deleteChildEntity: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteEntityDocument,
  graphqlVariables: (variables: { Id: string }) => ({ Id: variables.Id }),
  evictFields: ['entity', 'entity_by_pk'],
});
